import { render } from "./NegativeKeywordsModal.vue?vue&type=template&id=208505a8&scoped=true"
import script from "./NegativeKeywordsModal.vue?vue&type=script&lang=js"
export * from "./NegativeKeywordsModal.vue?vue&type=script&lang=js"

import "./NegativeKeywordsModal.vue?vue&type=style&index=0&id=208505a8&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208505a8"]])

export default __exports__